import NotFoundData from "components/NotFoundData";
import { Button, Row, Select } from "antd";
import styled from "@emotion/styled";
import { arrowUpDown } from "assets/icons";
import ProductByAgentCard from "./ProductByAgentCard";
import { ContactByIdResponse } from "services/interface";

interface ProductByAgentProps {
  data: ContactByIdResponse
}

const ProductByAgent = () => {
  const data = [];

  if (data.length === 0)
    return (
      <>
        <NotFoundData text="ยังไม่มีสินค้าในตอนนี้" />
      </>
    );

  const onChange = (value: string) => {
   // console.log(`selected ${value}`);
  };

  const onSearch = (value: string) => {
    //console.log("search:", value);
  };

  return (
    <>
      <ButtonWrapper>
        <Button size="middle" type="default">สินค้าทั้งหมด</Button>
        <Select
        style={{ width: 150 }}
          showSearch
          placeholder="แบ่งตามหมวดหมู่"
          optionFilterProp="children"
          onChange={onChange}
          onSearch={onSearch}
          filterOption={(input, option) =>
            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
          }
          options={[
            {
              value: "jack",
              label: "Jack",
            },
            {
              value: "lucy",
              label: "Lucy",
            },
            {
              value: "tom",
              label: "Tom",
            },
          ]}
        />
           <Button icon={<>{arrowUpDown}</>} type="default">ราคา</Button>
      </ButtonWrapper>
      <Row gutter={[8,8]} style={{ backgroundColor: "#EFEFEF", overflow: "auto", padding: 5 }}>
        <ProductByAgentCard />
        <ProductByAgentCard />
        <ProductByAgentCard />
        <ProductByAgentCard />
        <ProductByAgentCard />
      </Row>
    </>
  );
};

export default ProductByAgent;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  background-color: #efefef;
  padding: 10px;
  gap: 10px;
`;
